import styled from '@emotion/styled'
import { pxToRem } from 'utils/styled'

export const SFaqContactUs = styled.div`
  max-width: ${pxToRem(235)}rem;
  border: 2px solid var(--c-blue100);
  border-radius: 4px;
  padding: 1rem;

  transition: border-color 0.3s;

  &:hover {
    border-color: var(--c-blue200);
  }

  & svg {
    transform: translateX(8px) rotate(180deg);
    transition: transform 0.3s;
  }

  &:hover svg {
    transform: translateX(12px) rotate(180deg);
  }
`
